<template>
          <div class='card'>
                    <!-- <div class='card-header '>
                            <h4 >Detalhes da compra! </h4>
                    
                    </div> -->
                    <div class='card-body'>
                        
                        <div>
                            <dl class="row">
                                <dt class="col-sm-3">Descrição</dt>
                                <dd class="col-sm-9">{{order.orderDescription}}</dd>
                                <dt class="col-sm-3">Total:</dt>
                                <dd class="col-sm-9">{{order.totalPrice}}</dd>
                                <dt class="col-sm-3">Total em desconto:</dt>
                                <dd class="col-sm-9">{{order.totalDiscount}}</dd>
                            </dl>
                            <!-- <pre>{{order}}</pre> -->
                            
                        </div>

                    </div>
                </div>
        
</template>

<script>
export default {
    props:['order']
}

</script>

<style>

</style>
